<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AHPnqv/tc-custom/9781453229217.jpg?1708745736446" alt="This image is the cover for the book Bank Shot, The Dortmunder Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bank Shot, The Dortmunder Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A crew of thieves hopes to hijack a mobile home full of money in this crime caper from “the funniest man in the world” (<i>The Washington Post</i>).</b><br/><br/> John Dortmunder has been working an encyclopedia-selling scam while waiting for his next big heist. Unfortunately, his latest mark seems to be wise to the con, and he has to cut his sales pitch short and make a quick escape.<br/>  <br/> But opportunity awaits: Main Street bank has temporarily relocated to a mobile home. All Dortmunder has to do is get past seven security guards, put the bank-on-wheels in gear, and drive away. It’s a simple plan, until it all goes wrong . . .<br/>  <br/> Perfect for fans of Carl Hiaasen or Lawrence Block’s Bernie Rhodenbarr series, the Dortmunder novels by <i>New York Times</i>–bestselling and multiple Edgar Award–winning author Donald E. Westlake are a rollicking treat that combine fast-moving suspense with laugh-out-loud wit. <i>Bank Shot</i> is a “hilarious” standout in the series (<i>The New York Times</i>).<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Donald E. Westlake
      </h2>
      
      <p class="authorDescription body article">Donald E. Westlake (1933&ndash;2008) was one of the most prolific and talented authors of American crime fiction. He began his career in the late 1950s, churning out novels for pulp houses&mdash;often writing as many as four novels a year under various pseudonyms&mdash;but soon began publishing under his own name. His most well-known characters were John Dortmunder, an unlucky thief, and a ruthless criminal named Parker. His writing earned him three Edgars and a Grand Master Award from the Mystery Writers of America.&#160;Westlake&rsquo;s cinematic prose and brisk dialogue made his novels attractive to Hollywood, and several motion pictures were made from his books, with stars such as Lee Marvin and Mel Gibson. Westlake wrote several screenplays himself, receiving an Academy Award nomination for his adaptation of <i>The Grifters</i>, Jim Thompson&rsquo;s noir classic. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mysterious Press/Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e1ab86ba